// extracted by mini-css-extract-plugin
module.exports = {"group-feed-container":"group-feed-container___15S7P","panel-text":"panel-text___39UhD"};